/**
 * SeoPartAndAccessories Functional Component
 * @Package - seo
 * @Author - Cybage@UPWA-Team
 * @description: Common SEO PartAndAccessories
 */
/**
 *   SEO's PartAndAccessories Component
 */
import React, { useMemo } from 'react'
import { Title } from '@usap/widgets'
import PartAndAccessoriesCard from '../seoComponents/PartAndAccessories/component'

import {
  Box,
  SeoPartAndAccessoriesBox,
  SeoPartAndAccessoriesContainer,
  PartAndAccessoriesHeadingBox,
} from './SeoPartAndAccessories.css'

export interface ISeoPartAndAccessoriesProps {
  id: string,
  records: any[]
  title: string,
  brandName: string,
  dualPartDisplay: boolean,
  onItemClick?: () => void,
}

export default function SeoPartAndAccessories(props: ISeoPartAndAccessoriesProps) {
  const {
    id, records = [], title, brandName, dualPartDisplay, onItemClick = () => {},
  } = props

  const parseRecordId = string => string.replace(' ', '-').toLowerCase()
  const PartsToDisplay = useMemo(() => records.map(record => (
    <PartAndAccessoriesCard
      key={record.link}
      record={record}
      brandName={brandName}
      index={parseRecordId(record.text)}
      dualPartDisplay={dualPartDisplay}
      onItemClick={onItemClick}
    />
  )), [brandName, dualPartDisplay, records, onItemClick])

  return (
    <SeoPartAndAccessoriesBox>
      <SeoPartAndAccessoriesContainer id={id}>
        <PartAndAccessoriesHeadingBox id="PartAndAccessoriesHeading">
          <Title
            type="h2"
            size="20px"
            label={title}
          />
        </PartAndAccessoriesHeadingBox>

        <Box id="PartAndAccessoriesSection">
          <Box id="PartAndAccessoriesGrid" direction="row" wrap>
            {PartsToDisplay}
          </Box>
        </Box>
      </SeoPartAndAccessoriesContainer>
    </SeoPartAndAccessoriesBox>
  )
}
